import React, { useRef, useEffect, useState } from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import MainInvoiceContainer from './InvoiceContainer';

const InvoiceContainer = ({ invoiceData, invoiceContainerRef }) => {
    return (
        <div ref={invoiceContainerRef} style={{ width: '210mm', background: '#fff', padding: '10mm' }}>
            <MainInvoiceContainer invoiceData={invoiceData} />
        </div>
    );
};

const App = ({ invoiceData, setFillForm }) => {
    const invoiceContainerRef = useRef(null);
    const [isGenerating, setIsGenerating] = useState(false);

    const handleGeneratePdf = async () => {
        if (isGenerating) return;
        
        setIsGenerating(true);
        const invoiceContainer = invoiceContainerRef.current;

        if (!invoiceContainer) {
            console.error('Invoice container not found.');
            setIsGenerating(false);
            return;
        }

        try {
            const canvas = await html2canvas(invoiceContainer, { 
                scale: 2,
                useCORS: true,
                logging: true
            });
            const imgData = canvas.toDataURL('image/png');

            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: 'a4',
            });

            const imgWidth = 210; // A4 width in mm
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
            pdf.save('invoice.pdf');
            setFillForm(true);
        } catch (error) {
            console.error('Error generating PDF:', error);
            alert('An error occurred while generating the PDF.');
        } finally {
            setIsGenerating(false);
        }
    };

    // Auto-generate on mount
    useEffect(() => {
        handleGeneratePdf();
    }, []); // Empty dependency array ensures this runs only once on mount

    return (
        <div className="App">
            <InvoiceContainer invoiceContainerRef={invoiceContainerRef} invoiceData={invoiceData} />
            <button 
                onClick={handleGeneratePdf} 
                disabled={isGenerating}
                style={{ marginTop: '20px' }}
            >
                {isGenerating ? 'Generating...' : 'Download PDF Again'}
            </button>
        </div>
    );
};

export default App;